export {
  Separator,
  //
  Root,
} from './Separator';
export type { SeparatorProps } from './Separator';
